import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import {
  ListData,
  Data,
  MasterMerchant,
  DropdownData,
  PointHistory,
  PointSummary,
  PointRedeem,
} from './types'

export const selectListEvent = (state: RootState): Event => state.merchantsReducer.listEvent

export const selectList = (state: RootState): ListData => state.merchantsReducer.list

export const selectActionEvent = (state: RootState): Event => state.merchantsReducer.actionEvent

export const selectDetail = (state: RootState): Data | undefined => state.merchantsReducer.detail

export const selectDetailEvent = (state: RootState): Event => state.merchantsReducer.detailEvent

export const selectMasterMerchant = (state: RootState): MasterMerchant[] =>
  state.merchantsReducer.masterMerchantList

export const selectMerchantDropdown = (state: RootState): DropdownData[] =>
  state.merchantsReducer.merchantDropdown

export const selectPointHistory = (state: RootState): PointHistory => state.merchantsReducer.pointHistory

export const selectPointSummary = (state: RootState): PointSummary => state.merchantsReducer.pointSummary

export const selectPointRedeem = (state: RootState): PointRedeem => state.merchantsReducer.pointRedeem
